import Vue from 'vue'
const Base64 = require('js-base64').Base64

let loading
let loadStatus = false
// loading开始 方法
export const startLoading=(targetdq) =>{
  // console.log(112,document.querySelector(targetdq))
  if(!targetdq){
    return
  }else{
    if(loadStatus){
      // console.log(234)
      endLoading()
    }
    loadStatus = true
    console.log('loading',loadStatus)
    // element-ui loading 服务调用方式
    loading =Vue.prototype.$loading({
      customClass: 'loading_icon',
      lock: true,
      text: 'Loading...',
      spinner: 'el-icon-loading', // 自定义图标
      background: 'rgba(255, 255, 255, 0.2)',
      target:document.querySelector(targetdq)

    })
  }
 
}
// loading结束 方法
export const  endLoading = ()=>{
  loadStatus = false
  loading.close()
}

export const judgeLogin = ()=>{
   const localUser = localStorage.getItem('thesis-token');
    let token = ''
    if(localUser){
      const localToken = Base64.decode(localUser).split('----');
      token = localToken[1].replace(/\d{4}$/, '');
      const createTime = localToken[0];
      if(createTime && (new Date() - createTime) > (3600 * 1000 * 6 )) {
        localStorage.removeItem('thesis-token');
        localStorage.removeItem('userInfo');
        token=''
      }
    }
    if (!token) {
      return false
    } else {
      return true
    }
}